/* eslint-disable @typescript-eslint/no-explicit-any */

export function getMyTypeError<T extends { [key: string]: any }>(error: unknown, errKey: string): T | null {
  if (typeof error === 'object' && error !== null && errKey in (error as Record<string, any>)) {
    return error as T;
  }

  return null;
}
